// TODO: Replace this component by own logic or find more suitable lib
import Css from "./style.module.scss";

import { bind } from "decko";
import BrowserEvents from "const/BrowserEvents";
import React, { PureComponent } from "react";
import ReactDom from "react-dom";
import camelCase from "camelcase";
import classNames from "classnames";
import tagsInput from "tags-input";

const CONTAINER_CLASS_NAME = "tags-input";

const FORM_CONTROL_CLASS_NAME = "form-control";

const DELETE_KEY_CODE = 46;

const { CLICK, FOCUS, BLUR, INPUT, CHANGE, KEY_DOWN, MOUSE_DOWN } = BrowserEvents;

export default class TagsInput extends PureComponent {
  state = {
    autoCompleteOpened: false,
    autoCompletePlacementTop: false,
    autoCompleteSearch: ""
  };

  inputElementRef = null;

  autoCompleteElement = null;

  autoCompleteCloseTimeout = null;

  tagsContainerElement = null;

  tagInputElement = null;

  tags = null;

  constructor(props) {
    super(props);
    this.inputElementRef = React.createRef();
  }

  get dataset() {
    return Object.entries(this.props)
      .filter(([key]) => key.startsWith("data-"))
      .reduce((aggregator, [propKey, propValue]) => ({
        ...aggregator,
        [camelCase(propKey.split("-").slice(1).join("-"))]: propValue
      }), {});
  }

  @bind
  setAutoCompleteElement(element) {
    this.autoCompleteElement = element;
  }

  @bind
  toggleDisabledAttribute() {
    if (!this.tagsContainerElement || !this.tagInputElement) return;
    if (this.props.disabled) {
      this.tagsContainerElement.setAttribute("disabled", "");
      this.tagInputElement.setAttribute("disabled", "");
    } else {
      this.tagsContainerElement.removeAttribute("disabled");
      this.tagInputElement.removeAttribute("disabled");
    }
  }

  @bind
  toggleInvalidClassName() {
    const { invalid } = this.props;

    this.tagsContainerElement.classList.toggle("is-invalid", !!invalid);
    this.tagInputElement.classList.toggle("is-invalid", !!invalid);
  }

  @bind
  toggleAutoCompleteClassName() {
    const { autoCompleteOpened, autoCompletePlacementTop } = this.state;

    const autoCompleteVisible = autoCompleteOpened && !!this.autoCompleteElement;

    this.tagsContainerElement.classList.toggle(Css.autoCompleteOpened, autoCompleteVisible && !autoCompletePlacementTop);
    this.tagsContainerElement.classList.toggle(Css.autoCompleteOpenedTop, autoCompleteVisible && autoCompletePlacementTop);
  }

  @bind
  updateTags() {
    this.tags = this.tagsContainerElement.querySelectorAll(".tag");
    [...this.tags].forEach((tag) => {
      tag.setAttribute("title", tag.textContent);
      tag.removeEventListener(CLICK, this.handleTagClick);
      tag.addEventListener(CLICK, this.handleTagClick);
    });
  }

  @bind
  openAutoComplete() {
    const { autoCompleteData, disabled } = this.props;

    clearTimeout(this.autoCompleteCloseTimeout);
    this.autoCompleteCloseTimeout = null;
    if (disabled || !autoCompleteData || !autoCompleteData.length) return;
    this.setState({
      autoCompleteOpened: true,
      autoCompleteSearch: this.tagInputElement.value
    });
  }

  @bind
  closeAutoComplete() {
    this.setState({ autoCompleteOpened: false });
  }

  @bind
  selectAutoCompleteValue(value) {
    const nextValue = [...new Set([...(this.props.value || []), value])];

    this.tagsContainerElement.setValue(nextValue.join(","));
    this.props.onChange({
      target: {
        dataset: this.dataset,
        value: nextValue
      }
    });
    this.setState({
      autoCompleteOpened: false,
      autoCompleteSearch: ""
    });
  }

  @bind
  updateAutoCompletePlacement() {
    const { autoCompleteOpened, autoCompletePlacementTop } = this.state;

    if (!autoCompleteOpened || !this.autoCompleteElement) return;

    const { bottom, top } = this.tagsContainerElement.getBoundingClientRect();

    const { height } = this.autoCompleteElement.getBoundingClientRect();

    const bottomSpace = window.innerHeight - bottom;

    const shouldPlaceTop = height > bottomSpace && top > bottomSpace;

    if (shouldPlaceTop !== autoCompletePlacementTop) this.setState({ autoCompletePlacementTop: shouldPlaceTop });
  }

  componentDidMount() {
    const { className, type } = this.props;

    const { current: inputElement } = this.inputElementRef;

    const containerClassName = classNames(CONTAINER_CLASS_NAME, FORM_CONTROL_CLASS_NAME, className);

    tagsInput(inputElement);
    this.tagsContainerElement = inputElement.nextSibling;
    this.tagsContainerElement.className = containerClassName;
    this.tagsContainerElement.setAttribute("tabindex", 0);
    this.tagsContainerElement.addEventListener(FOCUS, this.handleTagsContainerFocus);
    this.tagsContainerElement.addEventListener(MOUSE_DOWN, this.handleTagsContainerMouseDown);
    this.tagInputElement = this.tagsContainerElement.querySelector("input");
    this.tagInputElement.className = FORM_CONTROL_CLASS_NAME;
    this.tagInputElement.setAttribute("autocomplete", "one-time-code");
    this.tagInputElement.setAttribute("type", type || "text");
    this.tagInputElement.setAttribute("name", `tagInput${Date.now()}`);
    this.tagInputElement.addEventListener(INPUT, this.handleTagsInputInput);
    this.tagInputElement.addEventListener(BLUR, this.handleTagsInputBlur);
    this.tagInputElement.addEventListener(KEY_DOWN, this.handleTagsInputKeyDown);
    inputElement.removeAttribute("style");
    inputElement.style.display = "none";
    inputElement.addEventListener(INPUT, this.handleSourceInputChange);
    inputElement.addEventListener(CHANGE, this.handleSourceInputChange);
    this.toggleDisabledAttribute();
    this.toggleInvalidClassName();
    this.updateTags();
  }

  componentDidUpdate(prevProps) {
    this.updateTags();
    if (this.props.disabled !== prevProps.disabled) this.toggleDisabledAttribute();
    if (this.props.invalid !== prevProps.invalid) this.toggleInvalidClassName();
    this.updateAutoCompletePlacement();
    this.toggleAutoCompleteClassName();
  }

  componentWillUnmount() {
    const { current: inputElement } = this.inputElementRef;

    clearTimeout(this.autoCompleteCloseTimeout);
    inputElement.removeEventListener(INPUT, this.handleSourceInputChange);
    inputElement.removeEventListener(CHANGE, this.handleSourceInputChange);
    this.tagInputElement.removeEventListener(KEY_DOWN, this.handleTagsInputKeyDown);
    this.tagInputElement.removeEventListener(INPUT, this.handleTagsInputInput);
    this.tagInputElement.removeEventListener(BLUR, this.handleTagsInputBlur);
    this.tagsContainerElement.removeEventListener(MOUSE_DOWN, this.handleTagsContainerMouseDown);
    this.tagsContainerElement.removeEventListener(FOCUS, this.handleTagsContainerFocus);
    this.tagsContainerElement.parentNode.removeChild(this.tagsContainerElement);
    [...this.tags].forEach((tag) => tag.removeEventListener(CLICK, this.handleTagClick));
  }

  @bind
  handleTagsContainerFocus() {
    this.tagInputElement.focus();
  }

  @bind
  handleTagsContainerMouseDown(event) {
    const { target } = event;

    if (target.closest(`.${Css.autoComplete}`)) return;
    if (target.classList.contains("tag")) return;
    event.preventDefault();
    this.tagInputElement.focus();
    setTimeout(this.openAutoComplete, 0);
  }

  @bind
  handleTagsInputInput({ target }) {
    const { autoCompleteData } = this.props;

    target.value = target.value.replace(/"/g, "");
    if (autoCompleteData && autoCompleteData.includes(target.value)) {
      this.selectAutoCompleteValue(target.value);
    } else {
      this.setState({ autoCompleteSearch: target.value });
      this.openAutoComplete();
    }
  }

  @bind
  handleTagsInputBlur() {
    const { value, onBlur } = this.props;

    clearTimeout(this.autoCompleteCloseTimeout);
    this.autoCompleteCloseTimeout = setTimeout(this.closeAutoComplete, 0);
    if (onBlur) onBlur({ target: { value, dataset: this.dataset } });
  }

  @bind
  handleTagsInputKeyDown({ keyCode }) {
    if (keyCode === DELETE_KEY_CODE) {
      [...this.tags].forEach((tag) => tag.classList.remove("selected"));
    }
  }

  @bind
  handleTagClick({ target }) {
    target.classList.add("selected");
    this.tagInputElement.dispatchEvent(new KeyboardEvent(KEY_DOWN, { keyCode: DELETE_KEY_CODE }));
  }

  @bind
  handleAutoCompleteItemMouseDown(event) {
    event.preventDefault();
    this.selectAutoCompleteValue(event.currentTarget.dataset.value);
  }

  @bind
  handleSourceInputChange({ target: { value } }) {
    this.props.onChange({
      target: {
        dataset: this.dataset,
        value: value.length ? [...new Set(value.split(","))].map((tag) => tag.trim()).filter((tag) => tag) : []
      }
    });
  }

  render() {
    let { invalid, value, autoCompleteData, onChange, ...restProps } = this.props;

    const { autoCompleteOpened, autoCompletePlacementTop, autoCompleteSearch } = this.state;

    if (autoCompleteData) autoCompleteData = autoCompleteData.filter((tag) => !value.includes(tag));

    const search = autoCompleteSearch.trim().toLowerCase();

    const autoCompleteOptions = autoCompleteData
      ? autoCompleteData.filter((tag) => !search || tag.toLowerCase().includes(search))
      : [];

    const autoComplete = autoCompleteOpened && !!autoCompleteOptions.length && (
      <div
        ref={this.setAutoCompleteElement}
        className={classNames(Css.autoComplete, { [Css.autoCompleteTop]: autoCompletePlacementTop })}>
        {autoCompleteOptions.map((tag) => (
          <div
            key={tag}
            data-value={tag}
            title={tag}
            className={Css.autoCompleteItem}
            onMouseDown={this.handleAutoCompleteItemMouseDown}>
            {tag}
          </div>
        ))}
      </div>
    );

    return (
      <>
        <input {...restProps} readOnly type="tags" value={value} className={Css.tagsInput} ref={this.inputElementRef} />
        {autoComplete && this.tagsContainerElement && ReactDom.createPortal(autoComplete, this.tagsContainerElement)}
      </>
    );
  }
}
